import { render, staticRenderFns } from "./ContractTemplateList.vue?vue&type=template&id=2ee240a2&"
import script from "./ContractTemplateList.vue?vue&type=script&lang=js&"
export * from "./ContractTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports